export { default } from './component'
